export const AvtalBenamningMaxLength = 50;
export const KontraktBenamningMaxLength = 50;
